import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

export const TODAY = moment().format('YYYY-MM-DD');

const initialState = {
	loading: false,
	recentlyVisitedUrl: '/',
	showLogout: false,
	invoiceDate: TODAY,
};

export const appSlice = createSlice({
	name: 'app',
	initialState,
	reducers: {
		showLoader: (state) => {
			state.loading = true;
		},
		hideLoader: (state) => {
			state.loading = false;
		},
		setRecentUrl: (state, { payload }) => {
			state.recentlyVisitedUrl = payload;
		},
		setShowLogout: (state, { payload }) => {
			state.showLogout = payload;
		},
		setinvoiceDate: (state, { payload = TODAY }) => {
			state.invoiceDate = payload;
		},
		setSalesmaninvoiceDate: (state, { payload = TODAY }) => {
			state.invoiceDate = payload;
		},
	},
});

export const {
	showLoader,
	hideLoader,
	setRecentUrl,
	setShowLogout,
	setinvoiceDate,
	setSalesmaninvoiceDate,
} = appSlice.actions;

export default appSlice.reducer;
